import React from 'react';
import { View, Text, StyleSheet, ScrollView } from 'react-native';
import BookingPaymentActions from '../components/BookingPaymentActions';

/**
 * Web-only minimal surface for Playwright: open app with ?e2e=prepay-buttons
 * (see App.tsx). Asserts the same BookingPaymentActions used in OneClick booking.
 */
const PrepayBookingE2EHarness: React.FC = () => {
  return (
    <ScrollView style={styles.scroll} contentContainerStyle={styles.content}>
      <Text style={styles.title}>BookAPT — prepay buttons (E2E)</Text>

      <Text style={styles.sectionLabel} testID="e2e-label-prepay-on">
        paymentRequiredAtBooking = true
      </Text>
      <View style={styles.card} testID="e2e-scenario-prepay-on">
        <BookingPaymentActions
          paymentRequiredAtBooking
          onPayNow={() => {}}
          onPayLater={() => {}}
        />
      </View>

      <Text style={styles.sectionLabel} testID="e2e-label-prepay-off">
        paymentRequiredAtBooking = false
      </Text>
      <View style={styles.card} testID="e2e-scenario-prepay-off">
        <BookingPaymentActions
          paymentRequiredAtBooking={false}
          onPayNow={() => {}}
          onPayLater={() => {}}
        />
      </View>

      <Text style={styles.sectionLabel} testID="e2e-label-price-on-request">
        price on request (showPayNow = false)
      </Text>
      <View style={styles.card} testID="e2e-scenario-price-on-request">
        <BookingPaymentActions
          paymentRequiredAtBooking={false}
          showPayNow={false}
          onPayNow={() => {}}
          onPayLater={() => {}}
        />
      </View>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  scroll: { flex: 1, backgroundColor: '#f8f9fa' },
  content: { padding: 24, paddingBottom: 48 },
  title: { fontSize: 20, fontWeight: '700', marginBottom: 24, color: '#1c1c1e' },
  sectionLabel: { fontSize: 15, fontWeight: '600', marginBottom: 8, color: '#444' },
  card: {
    backgroundColor: '#fff',
    borderRadius: 12,
    padding: 16,
    marginBottom: 28,
    borderWidth: 1,
    borderColor: '#e5e5ea',
  },
});

export default PrepayBookingE2EHarness;
